import {
   NEXT_FIRST_TAB,
   NEXT_SECOND_TAB,
   RETURN_TAB,
   USER_TYPE_GOODS,
   NEXT_THIRD_TAB,
   CALC_PRICE,
   CLEAR_INITIAL,
} from '../../utils/stringConsts';

const initialState = {
   section: 1,
   originLat: ' 51.40143',
   originLng: '32.4201',
   serviceTypeId: '',
   deliveryTypeId: '',
   fullName: null,
   phoneNumber: null,
   destination: 28,
   address: null,
   addressSender: null,
   postalCode: null,
   packages: [],
   packing: [],
   paymentTimeId: '1',
   assurance: {
      stat: false,
      value: null,
   },
   serviceFee: {
      stat: false,
      value: null,
      desc: '',
   },
   price: null,
   paymentTypeId: '2',
   packSize: [],
   cityName: '',
   origin: null,
   cities: [],
   states: [],
   paymentStatId: '1',
   pickup: true,
   packSizePackig: [],
   packSizePackages: [],
   nationalId: null,
};

const orderReducer = (state = initialState, action) => {
   switch (action.type) {
      case 'RESET_ORDER':
         return initialState;
      case USER_TYPE_GOODS:
         return {
            ...state,
         };
      case NEXT_FIRST_TAB:
         const {
            deliveryId,
            serviceId,
            cities,
            packSizePackages,
            packSizePacking,
            states,
            origin,
         } = action.payload;
         return {
            ...state,
            section: state.section + 1,
            serviceTypeId: serviceId,
            deliveryTypeId: deliveryId,
            cities: cities,
            packSizePackages,
            packSizePacking,
            states,
            origin,
         };
      case NEXT_SECOND_TAB:
         const { des, name, phone, postal, receiverAddress, nationalId } = action.payload;
         return {
            ...state,
            section: state.section + 1,
            destination: des,
            fullName: name,
            phoneNumber: phone,
            postalCode: postal,
            address: receiverAddress,
            nationalId,
         };
      case NEXT_THIRD_TAB:
         const { packes } = action.payload;
         return {
            ...state,
            section: state.section + 1,
            packages: packes,
         };

      case RETURN_TAB:
         return {
            ...state,
            section: state.section - 1,
         };
      case CALC_PRICE:
         const { price, packing, assurance, pickup } = action.payload;
         return {
            ...state,
            price,
            section: state.section + 1,
            packing,
            assurance,
            pickup,
         };

      case CLEAR_INITIAL:
         return initialState;

      default:
         return state;
   }
};

export default orderReducer;
